<template>
  <span v-if="valueExists && value !== 0">
    <span v-if="value > 0" class="increase">(+{{value}})</span>
    <span v-else class="decrease">({{value}})</span>
  </span>
</template>
<script>
export default {
  name: "ReportsValueDifference",
  props: {
    columnName: String,
    data: Object
  },
  computed: {
    valueExists: function() {
      return this.data.hasOwnProperty(this.columnName);
    },
    value: function() {
      return this.valueExists ? this.data[this.columnName] : 0;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/reports/ReportsValueDifference.vue